import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { stringActions } from '../../webapi';
import { EVENTS_DEFAULT_REMINDERS_ON, eventsRemindersOnUpdate, eventsRemindersOnLoaded } from '../../actions';
import { PlussCore } from '../../config/core';

const { Session, Components, Colours } = PlussCore;

class Configuration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      submitting: false,
      fetchingRemindersOn: true,
      remindersOn: false,
    };
  }

  UNSAFE_componentWillMount() {
    Session.checkLoggedIn(this);
  }

  componentDidMount() {
    if (!Session.validateAccess(this.props.auth.site, 'featurePicker', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    } else {
      this.props.eventsRemindersOnUpdate(this.props.auth.site, (remindersOn) => this.setState({ remindersOn, fetchingRemindersOn: false }));
    }
  }

  validateForm() {
    const { submitting, remindersOn } = this.state;
    if (submitting) return false;

    if (!_.isBoolean(remindersOn)) return false;

    return true;
  }

  onToggleRemindersOn = () => {
    if (this.state.fetchingRemindersOn) return;

    this.setState({ remindersOn: !this.state.remindersOn });
  };

  onSaveConfig = () => {
    if (!this.validateForm()) return;

    this.setState({ success: false, submitting: true }, async () => {
      try {
        const { remindersOn } = this.state;
        await stringActions.setString(this.props.auth.site, EVENTS_DEFAULT_REMINDERS_ON, remindersOn);
        this.props.eventsRemindersOnLoaded(remindersOn);

        this.setState({ success: true });
      } catch (error) {
        console.log('onSaveConfig - error', error);
        this.setState({ success: false });
      } finally {
        this.setState({ submitting: false });
      }
    });
  };

  renderConfigurations() {
    return (
      <div className="marginBottom-40">
        <Components.CheckBox
          label={`Do you want reminders on by default for events?`}
          isActive={this.state.remindersOn}
          onChange={this.onToggleRemindersOn}
        />
      </div>
    );
  }

  renderSubmit() {
    if (this.state.submitting) {
      return <Components.Button buttonType="secondary">Saving...</Components.Button>;
    }
    return (
      <Components.Button inline buttonType="primary" onClick={this.onSaveConfig} isActive={this.validateForm()}>
        Save
      </Components.Button>
    );
  }

  renderSuccess() {
    if (!this.state.success) return null;
    return <span style={{ ...styles.savedText, color: Colours.COLOUR_GREEN }}>Saved</span>;
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        <p className="fontMedium fontSize-36 text-dark marginBottom-32">Feature Configuration</p>
        {this.renderConfigurations()}
        <div style={{ paddingTop: 24, paddingBottom: 24 }}>
          {this.renderSubmit()}
          {this.renderSuccess()}
        </div>
      </div>
    );
  }
}

const styles = {
  statusCategoryHeading: {
    marginLeft: 130,
    width: 160,
    textAlign: 'center',
    marginBottom: 12,
  },
  statusTypeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  statusTextContainer: {
    width: 130,
  },
  statusCategoryContainer: {
    width: 160,
    textAlign: 'center',
  },
  statusIcon: {
    cursor: 'pointer',
    fontSize: 20,
    padding: 5,
    marginLeft: 10,
    color: Colours.COLOUR_BRANDING_ACTION,
    visibility: 'visible',
  },
  savedText: {
    fontSize: 14,
    lineHeight: '33px',
    marginLeft: 15,
  },
};

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
    remindersOn: state.events.remindersOn,
  };
};

export default connect(mapStateToProps, { eventsRemindersOnUpdate, eventsRemindersOnLoaded })(withRouter(Configuration));
